import TableRowActions from '@/components/TableRowActions/TableRowActions';

export default TableRowActions;
